module.exports = __webpack_public_path__ + "static/media/goat-with-cake.6ad9de23.svg";